import { MDBDatepicker, MDBBtn } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";

function parseMdbDate(dateStr) {
  if (!dateStr) return null;
  return dateStr.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$3-$2-$1");
}

function toMdbDate(isoStr) {
  if (!isoStr) return "";
  const [y, m, d] = isoStr.split("-");
  return `${d}.${m}.${y}`;
}

export default function DateRangeFilter({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  minDate,
  maxDate,
}) {
  const { t } = useTranslation();
  const hasRange = dateFrom || dateTo;

  return (
    <div className="d-flex gap-2 align-items-end flex-wrap">
      <div style={{ width: "150px" }}>
        <MDBDatepicker
          label={t("From")}
          format="dd.mm.yyyy"
          value={toMdbDate(dateFrom)}
          onChange={(val) => onDateFromChange(parseMdbDate(val))}
          min={minDate}
          max={maxDate}
          size="sm"
        />
      </div>
      <div style={{ width: "150px" }}>
        <MDBDatepicker
          label={t("To")}
          format="dd.mm.yyyy"
          value={toMdbDate(dateTo)}
          onChange={(val) => onDateToChange(parseMdbDate(val))}
          min={minDate}
          max={maxDate}
          size="sm"
        />
      </div>
      {hasRange && (
        <MDBBtn
          color="light"
          size="sm"
          onClick={() => { onDateFromChange(null); onDateToChange(null); }}
        >
          {t("Reset")}
        </MDBBtn>
      )}
    </div>
  );
}
